import React, { useEffect, useRef, useState, useMemo } from "react";
import { IProps as IScreenProps, Screen } from '~common/screen';
import { Styled } from './styled'
import { StyledScreen } from '~common/screen'
import { useIsMobile } from "~helpers/hooks/useIsMobile";
import { INTEGRATIONS_LIST, IIntegrationItem } from './constants/integrations-list'

interface IProps {
  title?: string | React.ReactNode,
  screenProps?: IScreenProps
}

const CrmsScreen: React.FC<IProps> = ({ title, screenProps }) => {
  const isMobile = useIsMobile()
  const imagesContainerRef = useRef(null)
  const [isShowedMore, setIsShowedMore] = useState(false)

  useEffect(() => {
    if (isMobile && (imagesContainerRef || {}).current) {
      const container  = imagesContainerRef.current
      container.scrollLeft = (container.scrollWidth - container.offsetWidth) / 2
    }
  }, [imagesContainerRef])

  const sectionTitle = useMemo(() => {
    if (title) return title

    return !isMobile
      ? <span>Бесплатно <StyledScreen.GreenText>интегрируем в CRM</StyledScreen.GreenText></span>
      : <span>Бесплатно<br /><StyledScreen.GreenText>интегрируем в CRM</StyledScreen.GreenText></span>

  }, [title, isMobile])

  const renderDescLogos = () => {
    return (
      <Styled.ImagesContainer ref={imagesContainerRef}>
        <Styled.ImagesRow>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/amo.svg'} alt='AmoCRMIcon'/>
          </Styled.Logo>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/bitrix24.svg'} alt='bitrix24'/>
          </Styled.Logo>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/getcourse.svg'} alt='getcourse'/>
          </Styled.Logo>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/yclients.svg'} alt='yclients'/>
          </Styled.Logo>
        </Styled.ImagesRow>
        <Styled.ImagesRow>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/roistat.svg'} alt='roistat'/>
          </Styled.Logo>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/moisklad.svg'} alt='moisklad'/>
          </Styled.Logo>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/remonline.svg'} alt='remonline'/>
          </Styled.Logo>
        </Styled.ImagesRow>
      </Styled.ImagesContainer>
    )
  }

  const renderMobileLogos = () => {
    return (
      <Styled.ImagesContainer ref={imagesContainerRef}>
        <Styled.ImagesRow>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/amo.svg'} alt='AmoCRMIcon'/>
          </Styled.Logo>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/bitrix24.svg'} alt='bitrix24'/>
          </Styled.Logo>
        </Styled.ImagesRow>
        <Styled.ImagesRow>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/getcourse.svg'} alt='getcourse'/>
          </Styled.Logo>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/yclients.svg'} alt='yclients'/>
          </Styled.Logo>
        </Styled.ImagesRow>
        <Styled.ImagesRow>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/roistat.svg'} alt='roistat'/>
          </Styled.Logo>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/moisklad.svg'} alt='moisklad'/>
          </Styled.Logo>
        </Styled.ImagesRow>
        <Styled.ImagesRow>
          <Styled.Logo>
            <img src={process.env.PUBLIC_DIR + '/images/index_page/crms/remonline.svg'} alt='remonline'/>
          </Styled.Logo>
        </Styled.ImagesRow>
      </Styled.ImagesContainer>
    )
  }

  return (
    <Screen
      id='integration'
      title={sectionTitle}
      {...screenProps}
    >
      {
        !isMobile
          ? renderDescLogos()
          : renderMobileLogos()
      }
      <Styled.MoreBtnContainer>
        <Styled.MoreBtn onClick={() => setIsShowedMore(!isShowedMore)}>Список готовых интеграций <Styled.MoreBtnArrow><Styled.MoreBtnArrowImg isShowed={isShowedMore} src={process.env.PUBLIC_DIR + '/images/arrow-down-blue.svg'} alt='arrow'/></Styled.MoreBtnArrow></Styled.MoreBtn>
      </Styled.MoreBtnContainer>
      <Styled.MoreIntegrationsContainer isShowed={isShowedMore}>
        {
          INTEGRATIONS_LIST.sort((a: IIntegrationItem, b: IIntegrationItem) => {
            if (a.order < b.order) return -1
            if (b.order < a.order) return 1
            return 0
          }).map((item, index) => (
            <Styled.IntegrationItem order={item.order} key={index}>{item.name}</Styled.IntegrationItem>
          ))
        }
      </Styled.MoreIntegrationsContainer>
    </Screen>
  )
}

export { CrmsScreen }
